import styled, { css } from "styled-components"

// this does not exist in QuorumDesign because it's not portable/reusable
// and does not invoke any variables from
// QuorumDesign/src/Components/rules.js
// QuorumDesign/src/Components/colors.js
export const StyledSearchifyActionButtons = styled.div`
    display: flex;
`

export const StyledSearchifyActionButtonsContainer = styled.div`
    background-color: white;
    display: flex;
    justify-content: ${({ shouldHideFilters }) => (shouldHideFilters ? "space-between" : "flex-end")};
    padding: 0 10px 18px 10px;
    position: sticky;
    top: 0;
    z-index: 1001;

    ${({ isMobile }) =>
        isMobile &&
        css`
            padding: 1rem 1rem 0.5rem;
            justify-content: space-between;
        `}
}
`
